var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 32,
    viewBox: "0 0 198 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 198,
    height: 32,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI Design x 23.08.23 - 29.08.23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1244 -747C-1244 -748.105 -1243.1 -749 -1242 -749H15606C15607.1 -749 15608 -748.105 15608 -747V11797C15608 11798.1 15607.1 11799 15606 11799H-1242C-1243.1 11799 -1244 11798.1 -1244 11797V-747Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Intro",
    clipPath: "url(#clip0_255_563)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    transform: "translate(-621 -30)",
    fill: "#0D0D17"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 363",
    filter: "url(#filter0_f_255_563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236 584C236 729.251 118.251 847 -27 847C-172.251 847 -290 729.251 -290 584C-290 438.749 -172.251 321 -27 321C118.251 321 236 438.749 236 584Z",
    fill: "#743FE0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "@1",
    filter: "url(#filter1_b_255_563)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_255_563",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-621 -30H819V62H-621V-30Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-621 -30H819V62H-621V-30Z",
    fill: "#131722",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.5832 6.80065C70.9014 6.80065 68.6709 7.70345 66.945 9.5356C65.219 11.3678 64.3428 13.6513 64.3428 16.4394C64.3428 19.2274 65.219 21.511 66.945 23.3431C68.6975 25.1753 70.9279 26.0781 73.6363 26.0781C78.0972 26.0781 80.9649 23.8211 82.027 19.8647H78.8407C78.0972 21.9624 76.3713 23.29 73.6363 23.29C71.8042 23.29 70.3172 22.6528 69.1754 21.3517C68.0336 20.0506 67.476 18.4308 67.476 16.4394C67.476 14.4479 68.0336 12.8016 69.1754 11.5271C70.3172 10.226 71.7776 9.58871 73.5832 9.58871C76.1854 9.58871 77.8848 10.6774 78.6814 12.8813H81.9739C80.9384 9.0842 78.0175 6.80065 73.5832 6.80065Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4911 12.1643C89.3669 12.1643 88.0392 13.1999 87.5347 14.5807L87.2957 12.2971H84.8263V25.7329H87.6409V18.7495C87.6675 17.5015 88.0392 16.5456 88.8092 15.9083C89.4996 15.2976 90.4024 15.0055 91.4911 15.0055V12.1643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.39 12.2971L99.2564 21.2986L98.9908 22.3872L98.7253 21.2986L95.6186 12.2971H92.5916L97.5039 25.547L95.3531 31.4418H98.3005L105.417 12.2971H102.39Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.995 12.005C113.03 12.005 111.543 12.7485 110.56 14.2089L110.375 12.2971H107.905V31.4418H110.746V24.0601C111.49 25.2018 113.003 26.025 114.995 26.025C116.827 26.025 118.314 25.3612 119.482 24.0335C120.677 22.6793 121.261 21.0065 121.261 19.015C121.261 17.0235 120.677 15.3507 119.509 14.0231C118.34 12.6689 116.827 12.005 114.995 12.005ZM114.49 14.6603C116.747 14.6603 118.34 16.4394 118.34 19.015C118.34 20.2895 117.969 21.3251 117.225 22.1483C116.508 22.9714 115.579 23.3697 114.464 23.3697C113.455 23.3697 112.578 22.9714 111.808 22.2014C111.065 21.4048 110.693 20.3692 110.667 19.0681V18.9088C110.667 17.6343 111.038 16.5987 111.808 15.8287C112.578 15.0586 113.455 14.6603 114.49 14.6603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.879 9.00454L124.852 12.2971H122.489V14.8993H124.852L124.799 21.8827C124.773 24.6708 126.127 25.9188 128.888 25.9188C129.764 25.9188 130.455 25.8126 130.959 25.6267V23.1307C130.535 23.2635 130.03 23.3431 129.446 23.3431C128.065 23.3431 127.614 22.759 127.614 21.272L127.667 14.8993H130.959V12.2971H127.693L127.72 9.00454H124.879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.658 13.9699C133.357 15.271 132.719 16.9704 132.719 19.015C132.719 21.0596 133.357 22.759 134.658 24.0601C135.959 25.3612 137.605 26.025 139.623 26.025C141.641 26.025 143.287 25.3612 144.588 24.0601C145.89 22.759 146.553 21.0596 146.553 19.015C146.553 16.9704 145.89 15.271 144.588 13.9699C143.287 12.6689 141.641 12.005 139.623 12.005C137.605 12.005 135.959 12.6689 134.658 13.9699ZM142.517 15.8552C143.261 16.6783 143.633 17.7405 143.633 19.015C143.633 20.2895 143.261 21.3517 142.517 22.1748C141.8 22.9979 140.845 23.4228 139.65 23.4228C138.455 23.4228 137.499 22.9979 136.755 22.1748C136.012 21.3517 135.64 20.2895 135.64 19.015C135.64 17.7405 136.012 16.6783 136.755 15.8552C137.499 15.0321 138.455 14.6072 139.65 14.6072C140.845 14.6072 141.8 15.0321 142.517 15.8552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.109 12.2971C155.498 12.1112 154.861 12.005 154.197 12.005C152.631 12.005 151.356 12.4564 150.374 13.3592C149.391 14.262 148.913 15.4038 148.913 16.8111C148.913 17.8467 149.205 18.7495 149.789 19.5726C148.86 20.2895 148.409 21.2189 148.409 22.3607C148.409 23.5821 148.966 24.5115 150.108 25.1753C149.152 25.7329 148.674 26.5295 148.674 27.5916C148.674 30.2469 150.798 31.7339 154.649 31.7339C158.18 31.7339 160.384 30.0345 160.384 27.1402C160.384 24.777 158.87 23.3962 156.082 23.3962H152.71C151.754 23.3962 151.17 22.9183 151.17 22.1483C151.17 21.6703 151.303 21.2986 151.595 21.0065C152.365 21.3517 153.215 21.5375 154.197 21.5375C155.737 21.5375 156.985 21.0861 157.941 20.2099C158.897 19.3071 159.375 18.1653 159.375 16.8111C159.375 16.0942 159.216 15.4038 158.924 14.74H161.074V12.2971H156.109ZM154.171 14.3151C155.658 14.3151 156.64 15.3241 156.64 16.8111C156.64 18.2184 155.658 19.2805 154.171 19.2805C152.684 19.2805 151.675 18.2184 151.675 16.8111C151.675 15.3241 152.657 14.3151 154.171 14.3151ZM155.445 25.6798C156.906 25.6798 157.622 26.2109 157.622 27.2995C157.622 28.7334 156.64 29.4503 154.649 29.4503C152.631 29.4503 151.462 28.7599 151.462 27.4057C151.462 26.3436 152.153 25.7595 153.135 25.6798H155.445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.75 12.1643C167.625 12.1643 166.298 13.1999 165.793 14.5807L165.554 12.2971H163.085V25.7329H165.9V18.7495C165.926 17.5015 166.298 16.5456 167.068 15.9083C167.758 15.2976 168.661 15.0055 169.75 15.0055V12.1643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.781 12.005C175.268 12.005 174.046 12.4564 173.117 13.3327C172.188 14.2089 171.683 15.2976 171.63 16.6518H174.365C174.365 15.3507 175.401 14.5276 176.781 14.5276C178.242 14.5276 178.985 15.3241 178.985 16.9439V17.5546L175.162 18.245C172.533 18.7495 171.232 20.0506 171.232 22.2014C171.232 24.5646 172.825 26.025 175.241 26.025C177.074 26.025 178.401 25.3346 179.198 23.9804L179.331 25.7329H181.827V16.8908C181.827 13.731 179.941 12.005 176.781 12.005ZM178.985 20.1568C178.985 20.9799 178.773 21.6703 178.348 22.281C177.79 23.1573 176.994 23.5821 175.905 23.5821C174.737 23.5821 174.073 22.9979 174.073 22.0686C174.073 21.1923 174.631 20.6082 175.772 20.3692L178.985 19.6788V20.1568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.915 6.34925V13.9699C193.985 12.6689 192.578 12.005 190.64 12.005C188.807 12.005 187.32 12.6689 186.126 14.0231C184.957 15.3507 184.373 17.0235 184.373 19.015C184.373 21.0065 184.957 22.6793 186.126 24.0335C187.294 25.3612 188.781 26.025 190.613 26.025C192.578 26.025 194.065 25.3081 195.074 23.8476L195.26 25.7329H197.729V6.34925H194.915ZM191.144 14.6869C192.153 14.6869 193.029 15.0852 193.799 15.8818C194.569 16.6518 194.941 17.6874 194.941 18.9885V19.1212C194.941 20.4223 194.569 21.4579 193.799 22.2279C193.056 22.9979 192.153 23.3697 191.118 23.3697C188.861 23.3697 187.294 21.5906 187.294 19.015C187.294 16.4659 188.914 14.6869 191.144 14.6869Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.270508 21.3324H12.4404V31.9989H0.270508V21.3324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4417 10.6662H24.6116V21.3327L12.4404 21.3324L12.4417 10.6662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4417 10.6662L24.6115 0L24.6116 10.6662H12.4417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6115 32.0001L12.4417 21.3336L24.6116 21.3327L24.6115 32.0001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6096 21.3324H36.7795V31.9989H24.6096V21.3324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7789 10.6662L48.9488 21.3327L36.7795 21.3324L36.7789 10.6662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9488 21.3327L36.7795 31.9989V21.3324L48.9488 21.3327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6096 0H36.7795L36.7789 10.6662L24.6096 10.6665V0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M819 61.6H-621V62.4H819V61.6Z",
    fill: "url(#paint0_linear_255_563)",
    mask: "url(#path-4-inside-1_255_563)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-1242 -748H15606V-750H-1242V-748ZM15607 -747V11797H15609V-747H15607ZM15606 11798H-1242V11800H15606V11798ZM-1243 11797V-747H-1245V11797H-1243ZM-1242 11798C-1242.55 11798 -1243 11797.6 -1243 11797H-1245C-1245 11798.7 -1243.66 11800 -1242 11800V11798ZM15607 11797C15607 11797.6 15606.6 11798 15606 11798V11800C15607.7 11800 15609 11798.7 15609 11797H15607ZM15606 -748C15606.6 -748 15607 -747.552 15607 -747H15609C15609 -748.657 15607.7 -750 15606 -750V-748ZM-1242 -750C-1243.66 -750 -1245 -748.657 -1245 -747H-1243C-1243 -747.552 -1242.55 -748 -1242 -748V-750Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_255_563",
    x: -1090,
    y: -479,
    width: 2126,
    height: 2126,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 400,
    result: "effect1_foregroundBlur_255_563"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_255_563",
    x: -641,
    y: -50,
    width: 1480,
    height: 132,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_255_563"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_255_563",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_255_563",
    x1: -621,
    y1: -30,
    x2: 143.317,
    y2: 732.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFD",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_255_563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white",
    transform: "translate(-621 -30)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainIcon);
export default __webpack_public_path__ + "static/media/main-icon.c04348c2551fd3c48b6e63b8381a768a.svg";
export { ForwardRef as ReactComponent };